/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {
  startLoadingSend,
  stopLoadingSend,
} from '../../../../Redux/FrontEnd/Loading/LoadingSendSlice'
import {GetCurrentData} from '../../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../../_metronic/helpers'
import { REGION_API_URLS } from '../../../../Utils/Constant/ConstantForWebsite'

const API_URL = ENV().REACT_APP_API_URL
const API_V2_URL = ENV().REACT_APP_API_V2_URL
const API_BE_URL = ENV().REACT_APP_BE_API_URL
const API_URL_V3 = ENV().REACT_APP_API_V3_URL

const fetchDataApiV3 = async (url: string, data: any, region: string) => {
  const domain = region !== defaultRegion ? (region && REGION_API_URLS[region.toUpperCase()]) || API_URL_V3 : API_URL
  const response = await axios.post(`${domain}${url}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`, region: region},
  })

  return response.data
}

const initialState = {
  sendBulkMessageData: {},
  savedCampaigns: {},
  previoslySendCampaign: {},
  reviewData: {},
  segmentTagsList: [],
  BulkMsgDraftData: {
    name: '',
    campaign_type: 'promotional',
    previouslySendId: {value: '', label: 'Select'},
    saveCampaignId: '',
    camp_type: 'sms',
    media: '',
    gif: '',
    message: '',
    messageSecond: '',
    subject: '',
    abTest: false,
    optout: false,
    optoutSecond: false,
    replyStopToOptOut: true,
    replyStopToOptOutSecond: true,
    to: {
      selectedType: '',
      value: '',
    },
    longUrl: [],
    longUrlSecond: [],
    when: '',
    whenSecond: '',
    sender: {value: '', label: ''},
    selectedTemplate: {value: '', label: 'Select Template'},
    interval: '',
    quantity: '',
    staggerMessages: false,
    landingPageId: '',
    landingPageIdSecond: '',
    senderType: '',
    filetype: '',
    url: '',
    mediaType: '',
    fileName: '',
  },
  totalCount: 0,
  totalCounts: 0,
  totalUnsubscribedCount: 0,
}

const RouteUrl = {
  CreateUploadListForBulkMessage: 'group',
  CreateUploadListForBulkMessagePost: 'mobile/group/',
}
const thunkName = {
  CreateUploadListForBulkMessage: 'group-Create',
  CreateUploadListForBulkMessagePost: 'group-Createpost',
}
///Upload bulk message contact////////////////////
export const CreateUploadListForBulkMessage: any = createAsyncThunk(
  thunkName.CreateUploadListForBulkMessage,
  async (data: any, thunkApi) => {
    // thunkApi.dispatch(startLoadding())

    const response = await axios.post(
      `${API_URL}${RouteUrl.CreateUploadListForBulkMessage}`,
      data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    {
      response.data?.status == true && toast.success(response.data.message)
    }

    return response.data
  }
)
export const CreateUploadListForBulkMessagePost: any = createAsyncThunk(
  thunkName.CreateUploadListForBulkMessagePost,
  async (data: any, thunkApi: any) => {
    // thunkApi.dispatch(startLoadding())
    let {subscriberData} = thunkApi.getState()

    const response = await axios.put(
      `${API_V2_URL}${RouteUrl.CreateUploadListForBulkMessagePost}${subscriberData?.FieldName?.data?._id}`,
      data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    return response.data
  }
)
export const GetSavedCampaigsList: any = createAsyncThunk(
  'GetSavedCampaigsList',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}draftcampaign`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const GetPrevioslySentCampaigsList: any = createAsyncThunk(
  'GetPrevioslySentCampaigsList',
  async (data: any, thunkApi) => {
    const {userId, ...restParams} = data || {}
    const response = await axios.get(`${API_URL}gateway/bulk`, {
      params: {
        ...restParams,
        ...(userId ? {user: userId} : {}),
      },
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const SaveCampaigsData: any = createAsyncThunk(
  'SaveCampaigsData',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}draftcampaign`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data.success == true && toast.success('Saved successfully')
    }
    thunkApi.dispatch(GetSavedCampaigsList())
    return response.data
  }
)
export const totalRecipients: any = createAsyncThunk(
  'totalRecipients',
  async (data: any, thunkApi) => {
    const currentUser = GetCurrentData()

    /** To get data from international service */
    if (currentUser?.region !== defaultRegion) {
      const resGroup = await axios.get(`${API_URL}mobile/group`, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })

      const payload: any = {
        page: 1,
        limit: 1,
        group_id: resGroup?.data?.data?._id,
      }

      if (data?.to?.selectedType === 'segmentOrTags') {
        if (data?.to?.value === '') {
          return {
            data: {
              totalContactCount: 0,
            },
          }
        }

        const tagsIds = data?.to?.value?.map((it: string) =>
          it?.replace('tag_', '').replace('segment_', '')
        )

        payload['tag_ids'] = tagsIds
      }

      if (data?.to?.selectedType === 'all') {
        payload['status'] = 'subscribe'
      }

      const response = await fetchDataApiV3(
        'contact',
        {
          action: 'find_contact',
          data: payload,
        },
        currentUser?.region as string
      )
      return {
        data: {
          totalContactCount: response?.data?.total ?? 0,
        },
      }
    }

    const response = await axios.post(`${API_URL}gateway/getReceiptsCount`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const totalCounts: any = createAsyncThunk('totalCounts', async (data: any, thunkApi) => {
  const currentUser = GetCurrentData()


  if (currentUser?.region !== defaultRegion) {
    const response = await fetchDataApiV3(
      'contact',
      {
        action: 'count_contact',
        data: {
          status: 'subscribe',
          
        },
      },
      currentUser?.region as string
    )

    return {
      data: {
        totalContactCount: response?.data
      },
    }
  }

  const response = await axios.post(`${API_URL}gateway/getReceiptsCount`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  return response.data
})
export const getCampaignContacts: any = createAsyncThunk(
  'getCampaignContacts',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}gateway/getCampaignContacts`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const totalUnsubscribedContactCount: any = createAsyncThunk(
  'totalUnsubscribedContactCount',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}group/getUnsubCount/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const UpdateSaveCampaigsData: any = createAsyncThunk(
  'UpdateSaveCampaigsData',
  async (data: any, thunkApi) => {
    const response = await axios.put(
      `${API_URL}draftcampaign/update-campaign/${data.id}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    {
      response.data.success == true && toast.success('Update successfully')
    }
    thunkApi.dispatch(GetSavedCampaigsList())

    return response.data
  }
)
export const BulkMessageCopyPast: any = createAsyncThunk(
  'BulkMessageCopyPast',
  async (data: any, thunkApi: any) => {
    const response = await axios.post(`${API_V2_URL}mobile/group/uploadCustomContact`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }

    return response.data
  }
)

export const BulkMessageReview: any = createAsyncThunk(
  'BulkMessageReview',
  async (data: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(startLoadingSend('review'))

      let response: any
      if (data && data.camp_type && data.camp_type === 'mms') {
        response = await axios.post(`${API_V2_URL}gatewayMms/bulkSummary`, data, {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        })
      } else {
        let url = API_BE_URL
        // let url = API_V2_URL
        // const response = await axios.post(`${url}gateway/bulkSummary`, data, {
        //   headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        // })

        response = await axios.post(`${url}v2/gateway/bulkSummary`, data, {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        })
      }

      if (response.data?.status === true) toast.success(response.data.message)
      if (response.status && response.status === 404) {
        throw new Error('Something wrong when send data to server')
      }

      return response.data
    } catch (error: any) {
      console.error('[BulkMessageReview] error : ', error)
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data)
      } else if (error.request) {
        return thunkApi.rejectWithValue('No response from server')
      } else {
        return thunkApi.rejectWithValue(error.message)
      }
    } finally {
      thunkApi.dispatch(stopLoadingSend())
    }
  }
)
export const sendBulkMessageData: any = createAsyncThunk(
  'sendBulkMessageData',
  async (data: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(startLoadingSend('send'))
      let url = API_BE_URL
      // let url = API_V2_URL
      // using v1 for schedule and stagger Message
      // if(data?.staggerMessages){
      //   url = API_URL
      // }

      // const response = await axios.post(`${url}gateway/bulk`, data, {
      //   params: {mode: 'Mobile'},
      //   headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      // })

      const response = await axios.post(`${url}v2/gateway/bulk`, data, {
        params: {mode: 'Mobile'},
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })

      if (!response.data) {
        throw new Error('Something wrong when send data to server')
      }

      thunkApi.dispatch(GetPrevioslySentCampaigsList())
      thunkApi.dispatch(fetchAsyncUserDetails())
      {
        response?.data?.success == true && toast.success(response.data.queueResponse.Result)
      }

      if (response.status && response.status === 404) {
        throw new Error('Something wrong when send data to server')
      }

      return response?.data
    } catch (error: any) {
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data)
      } else if (error.request) {
        return thunkApi.rejectWithValue('No response from server')
      } else {
        return thunkApi.rejectWithValue(error.message)
      }
    } finally {
      thunkApi.dispatch(stopLoadingSend())
    }
  }
)
export const sendBulkMessagemmsData: any = createAsyncThunk(
  'sendBulkMessagemmsData',
  async (data: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(startLoadingSend('send'))
      const response = await axios.post(`${API_V2_URL}gatewaymms/bulk`, data, {
        params: {mode: 'Mobile'},
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })

      if (!response.data) {
        throw new Error('Something wrong when send data to server')
      }

      thunkApi.dispatch(GetPrevioslySentCampaigsList())
      thunkApi.dispatch(fetchAsyncUserDetails())
      {
        response?.data?.success == true && toast.success(response.data.queueResponse.Result)
      }

      if (response.status && response.status === 404) {
        console.log('[sendBulkMessagemmsData] reject : ', response)
        return thunkApi.rejectWithValue(response.statusText)
      }

      return response?.data
    } catch (error: any) {
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data)
      } else if (error.request) {
        return thunkApi.rejectWithValue('No response from server')
      } else {
        return thunkApi.rejectWithValue(error.message)
      }
    }
  }
)

const BulkMessageData = createSlice({
  name: 'BulkMessageData',
  initialState,
  reducers: {
    BulkMsgDraftData: (state, {payload}) => {
      const {scheduledAt, scheduledAtSecond, ...rest} = payload
      return {...state, BulkMsgDraftData: rest}
    },
    StoreReviewData: (state, {payload}) => {
      return {...state, reviewData: payload}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetSavedCampaigsList.fulfilled, (state, action) => {
      if (!action?.meta?.arg?.search) {
        return {...state, savedCampaigns: action?.payload}
      }

      return state
    })
    builder.addCase(GetPrevioslySentCampaigsList.fulfilled, (state, action) => {
      if (!action?.meta?.arg?.search) {
        return {...state, previoslySendCampaign: action?.payload}
      }

      return state
    })
    builder.addCase(CreateUploadListForBulkMessage.fulfilled, (state, action) => {
      return {...state, sendBulkMessageData: action?.payload?.data}
    })
    builder.addCase(CreateUploadListForBulkMessagePost.fulfilled, (state, action) => {
      return {...state, sendBulkMessageData: action?.payload?.data}
    })
    builder.addCase(BulkMessageCopyPast.fulfilled, (state, action) => {
      return {...state, sendBulkMessageData: action?.payload?.data}
    })
    builder.addCase(BulkMessageReview.fulfilled, (state, action) => {
      return {...state, reviewData: action?.payload?.data}
    })
    builder.addCase(totalRecipients.fulfilled, (state, action) => {
      return {...state, totalCount: action?.payload?.data}
    })
    builder.addCase(totalCounts.fulfilled, (state, action) => {
      return {...state, totalCounts: action?.payload?.data}
    })
    builder.addCase(getCampaignContacts.fulfilled, (state, action) => {
      return {...state, segmentTagsList: action?.payload?.data}
    })
    builder.addCase(totalUnsubscribedContactCount.fulfilled, (state, action) => {
      return {...state, totalUnsubscribedCount: action?.payload?.data}
    })
  },
})

export const {BulkMsgDraftData, StoreReviewData} = BulkMessageData.actions

export const getAllSavedCampaignsList = (state: any) => state.bulkMessageData.savedCampaigns
export const getAllPreviouslySendCampaignsList = (state: any) =>
  state.bulkMessageData.previoslySendCampaign
export const getCampaignsTagId = (state: any) => state.bulkMessageData
export const getReviewData = (state: any) => state.bulkMessageData?.reviewData
export const getTotalCount = (state: any) => state.bulkMessageData?.totalCount
export const getSegmentTagsList = (state: any) => state.bulkMessageData?.segmentTagsList
export const getTotalCounts = (state: any) => state.bulkMessageData?.totalCounts?.totalContactCount
export const getTotalUnsubscribeCount = (state: any) =>
  state.bulkMessageData?.totalUnsubscribedCount

export default BulkMessageData.reducer
